import Database from 'database';
import { Queue, Resposta } from 'models';
import { Creators as queueCreators } from './queue';
import Helpers from 'shared/helpers';

export const Types = {
  GET_RESPOSTAS: 'respostas/GET_RESPOSTAS',
  GET_RESPOSTAS_SUCCESS: 'respostas/GET_RESPOSTAS_SUCCESS',
  GET_RESPOSTAS_FAILED: 'respostas/GET_RESPOSTAS_FAILED',
  SAVE_RESPOSTAS: 'respostas/SAVE_RESPOSTAS',
  SAVE_RESPOSTAS_SUCCESS: 'respostas/SAVE_RESPOSTAS_SUCCESS',
  SAVE_RESPOSTAS_FAILED: 'respostas/SAVE_RESPOSTAS_FAILED',
};

const initialState = {
  data: [],
  error: null,
  loading: false,
};

export default function respostasReducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_RESPOSTAS:
      return { ...state, loading: true };
    case Types.GET_RESPOSTAS_SUCCESS:
      return { loading: false, ...action.payload };
    case Types.GET_RESPOSTAS_FAILED:
      return { ...state, loading: false, ...action.payload };
    case Types.SAVE_RESPOSTAS:
      return { ...state, loading: true };
    case Types.SAVE_RESPOSTAS_SUCCESS:
      return { loading: false, ...action.payload };
    case Types.SAVE_RESPOSTAS_FAILED:
      return { ...state, loading: false, ...action.payload };
    default:
      return state;
  }
}

export const Creators = {
  getRespostas: condition => async dispatch => {
    dispatch({ type: Types.GET_RESPOSTAS });
    try {
      const respostas = await Database.respostas
        .filter(condition || (() => true))
        .toArray();
      dispatch({
        type: Types.GET_RESPOSTAS_SUCCESS,
        payload: { data: respostas },
      });
    } catch (oof) {
      console.error(oof.message);
      dispatch({
        type: Types.GET_RESPOSTAS_FAILED,
        payload: { error: oof.message },
      });
    }
  },
  saveRespostas: (id, fase_id, details, condition) => async dispatch => {
    dispatch({ type: Types.SAVE_RESPOSTAS });
    try {
      const ids = [];
      await Helpers.asyncForEach(
        Object.entries(details.pergunta),
        async (resposta, index) => {
          const resp = new Resposta({
            pergunta_id: Number(resposta[0]),
            pem_id: Number(id),
            resposta: resposta[1],
          });
          await resp.save();
          ids.push(resp._id);
          if (index === Object.entries(details.pergunta).length - 1) {
            const queue = new Queue({
              url: `respostas/${id}`,
              table: 'respostas',
              localId: ids,
              requestBody: { ...details, fase_id },
            });
            await queue.save();

            dispatch(Creators.getRespostas(condition));
            dispatch(queueCreators.getQueue());
          }
        },
      );
    } catch (oof) {
      console.error(oof.message);
      dispatch({
        type: Types.SAVE_RESPOSTAS_FAILED,
        payload: { error: 'Serviço indisponível' },
      });
    }
  },
};
